import * as React from 'react';

import { isEqual } from 'lodash';

// useDeepMemo can memoize the given value and only call memoFn when the value is deeply changed.
// This is necessary for useGqlQuery, since useGqlQuery needs to send the query
// only if the `variables` and `skip` are changed.
export const useDeepMemo = <K, V>(memoFn: () => V, key: K): V => {
  // ref to keep last value
  const ref = React.useRef<{ key: K; value: V }>();

  // call memoFn only if value is deeply changed
  if (!ref.current || !isEqual(key, ref.current.key)) {
    ref.current = { key, value: memoFn() };
  }

  return ref.current.value;
};

export default useDeepMemo;
